'use-client';
import * as React from 'react';
import classNames from 'clsx';
import {
  formatClassNames,
  getDataAttributes,
  isEmptyObject,
} from '@wix/editor-elements-common-utils';
import type { SkinWPhotoProps } from '../SkinWPhoto';
import { WPhotoWrapper } from '../../WPhotoWrapper';
import Link from '../../../../Link/viewer/Link';
import WPhoto from '../../WPhotoBase';
import { selectProperComponent, getPropsForLink } from '../../../utils';
import semanticClassNames from '../../../WPhoto.semanticClassNames';
import skinsStyle from './styles/skins.scss';

const VintagePhotoSkin: React.FC<SkinWPhotoProps> = props => {
  const {
    id,
    className,
    customClassNames = [],
    link,
    imageProps,
    title,
    onClick,
    hasPlatformClickHandler = false,
    onClickBehavior,
    onDblClick,
    onMouseEnter,
    onMouseLeave,
    filterEffectSvgString,
    filterEffectSvgUrl,
    shouldHideTooltip,
  } = props;
  const ImageComp = selectProperComponent(onClickBehavior);
  const isPopUp = onClickBehavior === 'zoomMode';
  const linkProps = getPropsForLink({
    onClickBehavior,
    className: skinsStyle.link,
    link,
  });

  return (
    <WPhotoWrapper
      id={id}
      {...getDataAttributes(props)}
      className={classNames(
        skinsStyle.VintagePhoto,
        className,
        formatClassNames(semanticClassNames.root, ...customClassNames),
      )}
      title={title}
      onClick={onClick}
      onDblClick={onDblClick}
      withOnClickHandler={
        !isEmptyObject(link) || hasPlatformClickHandler || isPopUp
      }
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      filterEffectSvgString={filterEffectSvgString}
      filterEffectSvgUrl={filterEffectSvgUrl}
      shouldHideTooltip={shouldHideTooltip}
    >
      <Link {...linkProps}>
        <div className={skinsStyle.image_container}>
          <ImageComp
            id={`img_${id}`}
            {...imageProps}
            className={skinsStyle.image}
            link={isPopUp ? link : undefined}
          />
        </div>
        <div className={classNames(skinsStyle.tl, skinsStyle.corner)} />
        <div className={classNames(skinsStyle.tr, skinsStyle.corner)} />
        <div className={classNames(skinsStyle.bl, skinsStyle.corner)} />
        <div className={classNames(skinsStyle.br, skinsStyle.corner)} />
      </Link>
    </WPhotoWrapper>
  );
};

const VintagePhoto: React.FC<SkinWPhotoProps> = props => (
  <WPhoto {...props} skin={VintagePhotoSkin} />
);

export default VintagePhoto;
